export const initialUsers = [
  {
    id: 1,
    name: "John Doe",
    email: "john@example.com",
    password: "pass123",
    status: "pending",
    permissions: []
  },
  {
    id: 2,
    name: "Jane Smith",
    email: "jane@example.com",
    password: "pass456",
    status: "pending",
    permissions: []
  },
  {
    id: 3,
    name: "Mike Johnson",
    email: "mike@example.com",
    password: "pass789",
    status: "approved",
    permissions: ["Deck", "NOTAM"]
  },
  {
    id: 4,
    name: "Sarah Wilson",
    email: "sarah@example.com",
    password: "pass321",
    status: "approved",
    permissions: ["Deck", "Comment Monitoring"]
  },
  {
    id: 5,
    name: "Robert Brown",
    email: "robert@example.com",
    password: "pass654",
    status: "pending",
    permissions: []
  },
  {
    id: 6,
    name: "Emily Davis",
    email: "emily@example.com",
    password: "pass987",
    status: "approved",
    permissions: ["Location Search", "NOTAM"]
  },
  {
    id: 7,
    name: "David Miller",
    email: "david@example.com",
    password: "pass147",
    status: "pending",
    permissions: []
  },
  {
    id: 8,
    name: "Lisa Anderson",
    email: "lisa@example.com",
    password: "pass258",
    status: "approved",
    permissions: ["Dark Hawk", "Profiling"]
  },
  {
    id: 9,
    name: "James Wilson",
    email: "james@example.com",
    password: "pass369",
    status: "pending",
    permissions: []
  },
  {
    id: 10,
    name: "Maria Garcia",
    email: "maria@example.com",
    password: "pass741",
    status: "approved",
    permissions: ["Admin Panel", "Analytics"]
  },
  {
    id: 11,
    name: "Daniel Lee",
    email: "daniel@example.com",
    password: "pass852",
    status: "pending",
    permissions: []
  },
  {
    id: 12,
    name: "Sophie Taylor",
    email: "sophie@example.com",
    password: "pass963",
    status: "approved",
    permissions: ["Originator Tracker", "Relation Graph"]
  },
  {
    id: 13,
    name: "William Clark",
    email: "william@example.com",
    password: "pass159",
    status: "pending",
    permissions: []
  },
  {
    id: 14,
    name: "Emma White",
    email: "emma@example.com",
    password: "pass753",
    status: "approved",
    permissions: ["Comment Monitoring", "Location Search"]
  },
  {
    id: 15,
    name: "Oliver Martin",
    email: "oliver@example.com",
    password: "pass951",
    status: "pending",
    permissions: []
  },
  {
    id: 16,
    name: "Ava Thompson",
    email: "ava@example.com",
    password: "pass357",
    status: "approved",
    permissions: ["NOTAM", "Dark Hawk"]
  },
  {
    id: 17,
    name: "Lucas Rodriguez",
    email: "lucas@example.com",
    password: "pass159",
    status: "pending",
    permissions: []
  },
  {
    id: 18,
    name: "Isabella King",
    email: "isabella@example.com",
    password: "pass753",
    status: "approved",
    permissions: ["Profiling", "Analytics"]
  },
  {
    id: 19,
    name: "Mason Scott",
    email: "mason@example.com",
    password: "pass951",
    status: "pending",
    permissions: []
  },
  {
    id: 20,
    name: "Charlotte Green",
    email: "charlotte@example.com",
    password: "pass357",
    status: "approved",
    permissions: ["Relation Graph", "Admin Panel"]
  }
];